import React, { useEffect, useMemo, useState } from "react";
import {
  FormActionComponent,
  FormWrapperItem,
  HeaderComponent,
  HeaderListComponent,
  PageListComponent,
} from "containers/backend/common/component/Index";
import { capitalizeFirstLetter } from "helpers/functions";
import Wrapper from "containers/backend/common/component/Wrapper";
import { DATE_TIME_FORMAT, PATHS } from "constants/Define";
import { find, isEmpty } from "lodash";
import moment from "moment";
import "./styles.less";
import { useParams } from "react-router-dom";
import { getMomentDate } from "utils/commonUtils";
import useGetUsagePlanRateCodeDetail from "../../../../../hooks/ratecode/useGetUsagePlanRateCodeDetail";
import CalendarUsagePlanRender from "containers/backend/common/component/CalendarUsagePlanRender";
const propTypes = {};

const RateCodeUsagePlanDetail = (props) => {
  //! State
  const { t, match, history, rateCodeState, getRateCodeDetail } = props;
  const { name: nameDetail, code: codeDetail } = rateCodeState;
  const params = useParams();
  const [dateRangeCalendar, setDateRangeCalendar] = useState([moment().startOf('month'), moment().endOf('month')]);

  const getTitleHeader = () => {
    return capitalizeFirstLetter(
      `${t("navigation.usagePlanProducts")}`.toLowerCase()
    );
  };

  const rateCodeBody = useMemo(() => {
    if (codeDetail) {
      return {
        codes: [codeDetail],
        usedDateFrom: moment(dateRangeCalendar[0]).format(
          DATE_TIME_FORMAT.SHORT_DATE_EXPORT
        ),
        usedDateTo: moment(dateRangeCalendar[1]).format(
          DATE_TIME_FORMAT.SHORT_DATE_EXPORT
        ),
      };
    }
  }, [codeDetail, dateRangeCalendar]);

  const { usagePlan } = useGetUsagePlanRateCodeDetail(rateCodeBody);

  //! Effect
  useEffect(() => {
    const { productWarehouseGoodReceipts = [] } = usagePlan || {};
    const usedDateFromFullValue = getMomentDate(
      productWarehouseGoodReceipts?.[0]?.usedDateFrom
    );
    const usedDateToFullValue = getMomentDate(
      productWarehouseGoodReceipts?.[0]?.usedDateTo
    );

    if (usedDateFromFullValue && usedDateToFullValue) {
      setDateRangeCalendar([usedDateFromFullValue, usedDateToFullValue]);
    }
  }, [dateRangeCalendar,usagePlan]);

  useEffect(() => {
    getRateCodeDetail(params.id);
  }, [params.id, getRateCodeDetail]);

  //! Function
  const onChangeCalendar = (data) => {
    if (isEmpty(data.fullValue)) {
      setDateRangeCalendar([]);
      return;
    }
    setDateRangeCalendar(data.fullValue);
    return;
  };

  const onClickBack = () => {
    history.push({
      pathname: PATHS.RATECODE.LIST.path,
    });
  };

  const renderUI = (dateMomment) => {
      const day = moment(dateMomment).format("D");
      const isPast = moment(dateMomment).isBefore(moment().startOf("D"));
      const mapsProductUsagePlan = (usagePlan || [])
        ?.map((usagePlanItem) => {
          const product = usagePlanItem.products
            .map((productItem) => {
              const dateData = find(productItem?.useDates, (useDatesItem) =>
                moment(useDatesItem.useDate).isSame(dateMomment, "D")
              );
              if (dateData) {
                return { ...dateData, materialCode: productItem.materialCode };
              }
            })
            .filter((e) => e);
          if (product.length > 0) {
            return product;
          }
        })
        .filter((e) => e).flat();

      const hasInventory = mapsProductUsagePlan.length > 0 && mapsProductUsagePlan.filter(x=>x.stockQty > 0).length === mapsProductUsagePlan.length;

      return (
        <div
          className={`ant-fullcalendar-date ${hasInventory ? "cld-gray" : ""} ${
            isPast ? "cld-date-past" : ""
          }`}
        >
          <div className="ant-fullcalendar-value">{day}</div>
          <div className="ant-fullcalendar-content">
            {mapsProductUsagePlan?.length > 0 &&
              mapsProductUsagePlan.map((item) => {
                return (
                  <div>
                    {item.materialCode} ({item.coefficient || 0}) - {item.usedQty || 0}/{item.plannedQty || 0}
                  </div>
                )
              })
            }
          </div>
        </div>
      );
  }

  //! Render
  return (
    <PageListComponent>
      <HeaderListComponent
        path={match.path}
        groupPath={"warehousemanagement"}
        titleHeader={getTitleHeader()}
      />
      <FormActionComponent
        disableButtonSubmit
        onClickBack={() => onClickBack()}
      >
        <FormWrapperItem>
          <HeaderComponent
            title={`${t("navigation.usagePlanProducts")} ${
              nameDetail ? nameDetail : ""
            }`}
            className="col-md-12 mb-3 p-2 m-b"
            style={{ borderBottom: "1px solid rgb(230, 230, 230)" }}
          />

          {/* CALENDAR */}
          <Wrapper className="col-md-12">
            <CalendarUsagePlanRender
              disablePopover
              enablePopup={false}
              dateCellRender={(dateMomment) => renderUI(dateMomment)}
              onChangeCalendar={onChangeCalendar}
            />
          </Wrapper>
        </FormWrapperItem>
      </FormActionComponent>
    </PageListComponent>
  );
};

RateCodeUsagePlanDetail.propTypes = propTypes;
export default RateCodeUsagePlanDetail;
